const hasLeadingOrTrailingSpaces = (str = '') => {
  return /^\s|\s$/.test(str)
    ? 'Text must not have any leading or trailing spaces'
    : undefined;
};

export default hasLeadingOrTrailingSpaces;
